import { icons, circleoOutlinePath } from "@tmsw/powerups.ui.icons";

export type ButtonIconProps = {
  icon: string | any;
  iconRight?: boolean;
  shape?: string;
}

const defaultProps = {
  iconRight: false
};

export const ButtonIcon = ({ icon, iconRight, shape }:ButtonIconProps) => {

  const iconPathD = icons[icon];

  return (
    <span
      role="presentation"
      className="ButtonIcon"
        style={{
      alignSelf: iconRight ? 'end' : undefined
    }}
    >
      <svg viewBox="0 0 96 96" width="100%" height="100%">
        <path data-name="icon" data-icon={icon} d={iconPathD} fill="currentColor" />
        {shape === 'circle' && (<path data-name="outline" d={circleoOutlinePath} fill="currentColor" />)}
      </svg>
    </span>
  );
};

ButtonIcon.defaultProps = defaultProps;

export default ButtonIcon;
